import { Component, OnInit } from '@angular/core';
import { NavParams, ModalController } from '@ionic/angular';
import { DataService, LocalStorageService, AppService } from 'src/app/service';

@Component({
  selector: 'app-corp-select-report',
  templateUrl: './corp-select-report.component.html',
  styleUrls: ['./corp-select-report.component.scss'],
})
export class CorpSelectReportComponent implements OnInit {
  orgId: number; // 当前用户所属的最高组织架构
  selectedOrg: number; // 被选中的组织架构
  orgCrumbs = []; // 组织架构面包屑
  orgList = []; // 组织架构列表
  originalOrgList = []; // 组织架构列表-源数据
  search: string; // 搜索文本

  constructor(private navParams: NavParams,
    private modalController: ModalController,
    private appService: AppService,
    private dataService: DataService,
    private localStorageService: LocalStorageService) { }

  ngOnInit() {
    this.getCorporateById();
  }

  // 根据id获取组织架构
  getCorporateById() {
    this.orgList = [JSON.parse(this.localStorageService.getStore('Highest_Level_Org'))];
    this.originalOrgList = [JSON.parse(this.localStorageService.getStore('Highest_Level_Org'))];
    var obj:{[key: string]: any} = {
      full_name: '全部',
      id: 'all'
    }
    this.orgList.push(obj);
  }

  // 根据父id获取子组织架构
  getChildrenCorporate(id) {
    this.dataService.getCorporateByParent(id).subscribe(res => {
      if (res.STATUS === 0) {
        this.orgList = res.DATA;        
        this.originalOrgList = res.DATA;
      }
    }, (err) => {
      this.appService.toastTip('get_data_failed_key', true);
    });
  }

  // 点击组织架构面包屑
  clickOrgCrumbs(org, index) {
    if (index === this.orgCrumbs.length - 1 || this.orgCrumbs.length === 0) {
      return;
    } else {
      this.orgCrumbs = this.orgCrumbs.splice(0, index + 1);
      this.getChildrenCorporate(org.id);
    }
  }

  // 点击组织架构
  clickOrg(org) {
    this.selectedOrg = org;
  }

  // 搜索组织架构
  searchOrg() {
    if (this.search) {
      this.orgList = this.originalOrgList.filter(res => res.full_name.indexOf(this.search) !== -1);
    } else {
      Object.assign(this.orgList, this.originalOrgList);
    }
  }

  // 下一级
  nextLevel(org) {
    this.orgCrumbs.push(org);
    this.getChildrenCorporate(org.id);
  }

  // 关闭
  async close() {
    await this.modalController.dismiss();
  }

  // 确认
  async confirm() {
    await this.modalController.dismiss(this.selectedOrg);
  }
}
